import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MultiselectTypeDescriptions } from '../../lib/client-configuration';
import { ClientConfigurationOptionDefinition } from '../../../core/models/client-configuration-option-definition.model';
import { NgSelectComponent } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-client-configuration-multiselect',
    templateUrl: './client-configuration-multiselect.component.html',
    styleUrls: ['./client-configuration-multiselect.component.scss'],
    imports: [NgSelectComponent, FormsModule]
})
export class ClientConfigurationMultiselectComponent {
  @Input() definition: ClientConfigurationOptionDefinition;
  @Input() options: string[];
  @Input() selected: string[];

  @Output() selectedChange: EventEmitter<string[]> = new EventEmitter<string[]>();

  constructor() {}

  onChange(selected: string | string[]) {
    if (!Array.isArray(selected)) {
      selected = [selected]
    }
    this.selectedChange.emit(selected);
  }

  get label(): string {
    return (MultiselectTypeDescriptions[this.definition.dataType]);
  }
}
